import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddTeacherComp from "./Component/AddTeacherComp"


const AddTeacher =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddTeacherComp />
            
        </div>
        <Footer />
        </>
    )
}

export default AddTeacher